import { useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { SequenceTemplate } from "../types";

export const useSequenceOperations = () => {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  const handleDelete = async (id: string) => {
    if (!id) {
      console.error("No sequence ID provided for deletion");
      return;
    }

    try {
      // First delete all steps associated with this sequence
      const { error: stepsError } = await supabase
        .from('sequence_steps')
        .delete()
        .eq('sequence_id', id);

      if (stepsError) {
        throw new Error(`Failed to delete sequence steps: ${stepsError.message}`);
      }

      // Then delete the sequence itself
      const { error: sequenceError } = await supabase
        .from('sequence_templates')
        .delete()
        .eq('id', id);

      if (sequenceError) {
        throw new Error(`Failed to delete sequence: ${sequenceError.message}`);
      }

      // Update local cache immediately
      queryClient.setQueryData(['active-sequences'], (oldData: any) => {
        if (!oldData) return [];
        return oldData.filter((sequence: any) => sequence.id !== id);
      });

      toast({
        title: "Success",
        description: "Sequence deleted successfully",
      });

    } catch (error) {
      console.error("Error in handleDelete:", error);
      toast({
        title: "Error",
        description: error instanceof Error ? error.message : "Failed to delete sequence",
        variant: "destructive",
      });
      throw error; // Re-throw to handle in component
    }
  };

  return {
    handleDelete,
  };
};